import { Button, type ButtonProps } from './Button';
import { cn } from '../utils';

export function ChipButton(props: ButtonProps) {
	return <Button size="chip" appearance="solid" intent="none" {...props} className={cn('w-[50px] rounded-full py-1.5', props.className)} />;
}
